'use client';

import React, { Suspense } from 'react';
import dynamic from 'next/dynamic';
import PageLoader from '@/components/common/PageLoader';

const ApiDocsPageClient = dynamic(
    () => import('@/components/client/api_docs/ApiDocsPageClient'),
    {
        loading: () => (
            <PageLoader
                message="Loading API Documentation..."
                fullPage={true}
            />
        ),
        ssr: false,
    }
);

export default function ApiDocsDynamicPage() {
    return (
        <Suspense
            fallback={
                <PageLoader
                    message="Loading API Documentation..."
                    fullPage={true}
                />
            }
        >
            <ApiDocsPageClient />
        </Suspense>
    );
}
